import { useQuery } from "@tanstack/react-query";
import { getApiInstance } from "./config";
import { Collection } from "../types/collections.types";
import store2 from "store2";

export type CollectionAndFieldsPermission = {
    collections: Collection[];
    fields: any[];
};

export const useCollections = () => {
    return useQuery({
        queryKey: ["collections"],
        queryFn: async () => {
            const [collections, fields] = await Promise.all([getCollections(), getFields()]);

            return { collections, fields };
        },
        refetchOnWindowFocus: false,
        staleTime: Infinity,
    });
};

export const getCollections = async () => {
    const mainApi = getApiInstance();
    const mainResponse = await mainApi.get("/collections");
    const mainCollections = mainResponse.data.data;

    const financeAuth = store2.get("finance_auth");
    if (!financeAuth) {
        return mainCollections;
    }

    try {
        const financeApi = getApiInstance("finance");
        const financeResponse = await financeApi.get("/collections");
        const financeCollections = financeResponse.data.data;
        return [...mainCollections, ...financeCollections];
    } catch (error) {
        return mainCollections;
    }
};

export const getFields = async () => {
    const mainApi = getApiInstance();
    const mainResponse = await mainApi.get("/fields");
    const mainFields = mainResponse.data.data;

    const financeAuth = store2.get("finance_auth");
    if (!financeAuth) {
        return mainFields;
    }

    try {
        const financeApi = getApiInstance("finance");
        const financeResponse = await financeApi.get("/fields");
        const financeFields = financeResponse.data.data;
        return [...mainFields, ...financeFields];
    } catch (error) {
        return mainFields;
    }
};
